var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-poster-wrapper"},[_c('div',{staticClass:"poster-wrapper"},_vm._l((_vm.posters),function(item,index){return _c('div',{key:index,staticClass:"poster-item",on:{"click":function($event){return _vm.goDetail(item)}}},[_c('img',{attrs:{"src":item.icon,"alt":"","srcset":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }